import * as React from "react"
import { BlogItemsStyles } from "./BlogStyles"

const BlogItems = ({ children }) => {
  return <BlogItemsStyles>{children}</BlogItemsStyles>
}

export default BlogItems
